import { render } from "./MenuWrap.vue?vue&type=template&id=695b753e&scoped=true"
import script from "./MenuWrap.vue?vue&type=script&lang=js"
export * from "./MenuWrap.vue?vue&type=script&lang=js"

import "./MenuWrap.vue?vue&type=style&index=0&id=695b753e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-695b753e"]])

export default __exports__